<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo">
        <img src="../../static/img/logo3.png" class="Img"/>
      </el-col>
      <el-col :span="5" style="position: relative;height: 60px;">
      </el-col>
      <el-col :span="4" class="userinfo">
        <p>当前用户：<span>{{userName}}</span><span class="userinfo-inner" @click="logout">安全退出</span></p>
        <!--<el-dropdown trigger="hover">
            <span class="el-dropdown-link userinfo-inner"><img :src="this.sysUserAvatar" /> {{sysUserName}}</span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>我的消息</el-dropdown-item>
                <el-dropdown-item>设置</el-dropdown-item>
                <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>-->
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'" style="margin-top: 5px;">
        <!--导航菜单-->

        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen"
                 @close="handleclose" @select="handleselect"
                 unique-opened router v-show="!collapsed">
          <template>

            <el-menu-item v-if="Limits.stat_device_index" index="/DeviceStatusManagement"><i
              class="el-icon-upload"></i>设备状态管理
            </el-menu-item>

            <!--分析-->
            <el-submenu
              v-if="Limits.stat_summary_index||Limits.stat_new_online_index||Limits.stat_active_device_index||Limits.stat_active_device_stat||Limits.stat_online_condition_index"
              index="1">
              <template slot="title"><i class="el-icon-data-analyze"></i>物联数据分析</template>
              <el-menu-item v-if="Limits.stat_summary_index" index="/AnalyzeOverviewManagement">概览
              </el-menu-item>
              <!--<el-menu-item v-if="Limits.stat_new_online_index" index="/AnalyzeNewOnlineDeviceManagement">-->
                <!--新增上线-->
              <!--</el-menu-item>-->
              <el-menu-item v-if="Limits.stat_active_device_index" index="/AnalyzeActiveDeviceManagement">
                活跃设备
              </el-menu-item>
              <el-menu-item v-if="Limits.stat_active_device_stat" index="/AnalyzeActivePeriodManagement">
                活跃周期
              </el-menu-item>
              <el-menu-item v-if="Limits.stat_online_condition_index"
                            index="/AnalyzeOnlineDurationManagement">连接时长
              </el-menu-item>
            </el-submenu>

            <!--						<el-menu-item index="/main"><i class="el-icon-star-off"></i>首页</el-menu-item>-->
            <!--<el-menu-item index="/MessageCenter"><i class="el-icon-bell"></i>消息中心</el-menu-item>-->
            <!--						<el-menu-item v-if="Limits.dealer_index" index="/DealerManagement"><i class="el-icon-view"></i>经销商管理</el-menu-item>-->
            <!--						<el-submenu index="4" v-if="Limits.questionnaire_index">-->
            <!--							<template slot="title"><i class="el-icon-setting"></i>用户及设备画像</template>-->
            <!--							<el-menu-item index="/PortraitForUser">用户画像</el-menu-item>-->
            <!--							<el-menu-item index="/PortraitForEquipment">设备画像</el-menu-item>-->
            <!--						</el-submenu>-->
            <el-submenu index="2"
                        v-if="Limits.candidate_index || Limits.exhibition1_target_index || Limits.questionnaire_index || Limits.unallocatedreservation_index || Limits.allocatedreservation_index || Limits.feedback_index">
              <template slot="title"><i class="el-icon-service"></i>客户管理</template>
              <el-menu-item v-if="Limits.questionnaire_index" index="/CustomerInformation">客户信息管理
              </el-menu-item>
              <!--<el-menu-item index="/SmartCare">智能看护</el-menu-item>-->
              <el-menu-item v-if="Limits.questionnaire_index" index="/CustomerPopular">客户推广管理
              </el-menu-item>
              <el-menu-item v-if="Limits.exhibition1_target_index" index="/ActiveUser">北京福祉客户签到
              </el-menu-item>
              <el-menu-item v-if="Limits.candidate_index" index="/SeedCandidate">种子项目候选人</el-menu-item>
              <el-menu-item v-if="Limits.unallocatedreservation_index" index="/CustomerReservation">
                未分配预约管理
              </el-menu-item>
              <el-menu-item v-if="Limits.allocatedreservation_index" index="/CustomerReservationed">
                已分配预约管理
              </el-menu-item>
              <!--<el-menu-item v-if="Limits.feedback_index" index="/CustomerOpinion">客户意见反馈</el-menu-item>-->
            </el-submenu>

            <!--						<el-submenu index="5" v-if="Limits.device_info_index">-->
            <!--							<template slot="title"><i class="el-icon-sold-out"></i>售后管理</template>-->
            <!--							<el-menu-item index="/AfterSalesTracking">产品信息跟踪</el-menu-item>-->
            <!--							&lt;!&ndash;<el-menu-item index="/AfterSalesTrackingStand">产品信息跟踪[标准版]</el-menu-item>&ndash;&gt;-->
            <!--							-->
            <!--						</el-submenu>-->

            <el-submenu index="3"
                        v-if="Limits.sport_summary_index || Limits.dev_sport_data_index || Limits.dev_test_data_index || Limits.dev_sport_log_index || Limits.dev_sport_flash_log_index || Limits.device_index || Limits.dev_data_index || Limits.dev_log_index || Limits.dev_flash_log_index">
              <template slot="title"><i class="el-icon-data-management"></i>物联数据管理</template>
              <el-menu-item v-if="Limits.dev_test_data_index" index="/EquipmentMonitoringtest">
                设备监控日志[测试]
              </el-menu-item>
              <el-submenu index="3-1"
                          v-if="Limits.device_index || Limits.dev_data_index || Limits.dev_log_index || Limits.dev_flash_log_index">
                <template slot="title">标准版设备</template>
                <el-menu-item v-if="Limits.device_index" index="/EquipmentInformation">设备信息
                </el-menu-item>
                <el-menu-item v-if="Limits.dev_data_index" index="/EquipmentMonitoring">设备监控日志
                </el-menu-item>
                <el-menu-item v-if="Limits.dev_log_index" index="/EquipmentCycleLog">设备周期日志
                </el-menu-item>
                <el-menu-item v-if="Limits.dev_flash_log_index" index="/EquipmentFlash">设备Flash日志
                </el-menu-item>
              </el-submenu>

              <el-submenu index="3-2"
                          v-if="Limits.sport_summary_index || Limits.dev_sport_data_index || Limits.dev_sport_log_index || Limits.dev_sport_flash_log_index || Limits.dev_sport_error_log_index">
                <template slot="title">运动版设备</template>
                <el-menu-item v-if="Limits.sport_summary_index" index="/SportEquipment">设备信息
                </el-menu-item>
                <el-menu-item v-if="Limits.dev_sport_data_index" index="/SportMonitoring">设备监控日志
                </el-menu-item>
                <el-menu-item v-if="Limits.dev_sport_log_index" index="/SportCycleLog">设备周期日志
                </el-menu-item>
                <el-menu-item v-if="Limits.dev_sport_flash_log_index" index="/SportFlash">设备Flash日志
                </el-menu-item>
                <el-menu-item v-if="Limits.dev_sport_error_log_index" index="/SportErr">设备错误日志
                </el-menu-item>
              </el-submenu>

              <el-submenu index="3-3"
                          v-if="true">
                <template slot="title">智能轮椅</template>
                <el-menu-item v-if="true" index="/WheelChairMonitoring">监控日志[智能轮椅]
                </el-menu-item>
                <el-menu-item v-if="true" index="/WheelChairCycleLog">周期日志[智能轮椅]
                </el-menu-item>
                <el-menu-item v-if="true" index="/WheelChairFlash">Flash日志[智能轮椅]
                </el-menu-item>
                <el-menu-item v-if="true" index="/WheelChairErr">错误日志[智能轮椅]
                </el-menu-item>
              </el-submenu>
            </el-submenu>


            <el-submenu index="4"
                        v-if="Limits.task_index || Limits.nonwarehoused_index || Limits.warehoused_index">
              <template slot="title"><i class="el-icon-product-process"></i>生产流程管理</template>
              <el-menu-item v-if="Limits.task_index" index="/EquipmentBelow">设备下单管理</el-menu-item>
              <!--<el-menu-item index="/QRcodeDown">二维码下载管理</el-menu-item>-->
              <el-menu-item v-if="Limits.nonwarehoused_index" index="/StorageEquipment">待入库设备管理
              </el-menu-item>
              <el-menu-item v-if="Limits.warehoused_index" index="/WarehousingEquipment">已入库设备管理
              </el-menu-item>
            </el-submenu>
            <!--<el-menu-item index="/Log"><i class="el-icon-menu"></i>操作及安全日志</el-menu-item>-->

            <el-submenu index="5">
              <template slot="title"><i class="el-icon-other"></i>其他</template>
              <el-menu-item v-if="Limits.member_open_close_game" index="/MobileAppUserManagement">App用户管理
              </el-menu-item>
            </el-submenu>

            <!--<el-menu-item v-if="true" index="/OverviewManagement"><i class="el-icon-star-off"></i>概览-->
            <!--</el-menu-item>-->

            <el-submenu index="6">
              <template slot="title"><i class="el-icon-settings"></i>设置</template>
              <el-menu-item v-if="Limits.user_index" index="/AccountManagement">后台账户管理
              </el-menu-item>
              <el-menu-item v-if="Limits.role_index" index="/RoleManage">角色管理
              </el-menu-item>
            </el-submenu>

            <!--<el-menu-item v-if="Limits.stat_device_index" index="/WheelDeviceStatusManagement"><i-->
            <!--class="el-icon-star-off"></i>轮椅列表-->
            <!--</el-menu-item>-->
            <!--<el-menu-item v-if="true" index="/RemoteRehabitationServiceManagement"><i-->
            <!--class="el-icon-star-off"></i>远程康复服务-->
            <!--</el-menu-item>-->
          </template>
        </el-menu>
      </aside>
      <section class="content-container">
        <!--<div class="grid-content bg-purple-light">-->
        <el-col :span="24" class="breadcrumb-container" id="lbfbread">
          <strong class="title">{{$route.name}}</strong>
          <el-breadcrumb separator="/" class="breadcrumb-inner">
            <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
              {{ item.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>

        <el-col :span="24" class="content-wrapper">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </el-col>
        <!--</div>-->
      </section>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    data() {
      return {
        sysName: 'VUEADMIN',
        collapsed: false,
        sysUserName: '',
        sysUserAvatar: '',
        userName: "",
        Limits: "",
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      }
    },
    methods: {
      onSubmit() {
        console.log('submit!');
      },
      handleopen() {
        //console.log('handleopen');
      },
      handleclose() {
        //console.log('handleclose');
      },
      handleselect: function (a, b) {
      },
      //退出登录
      logout() {
        this.$confirm('确认退出吗?', '提示', {
          type: 'warning'
        }).then(() => {
          sessionStorage.removeItem('user');
          this.$router.push('/login');
        }).catch(() => {

        });
      },
      //折叠导航栏
      collapse: function () {
        this.collapsed = !this.collapsed;
      },
      showMenu(i, status) {
        this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
      }
    },
    created() {
      this.userName = sessionStorage.getItem("user")
      this.Limits = JSON.parse(sessionStorage.getItem("limits"))
//			console.log("dev-data_index",this.Limits.dev-data_index)
    },
    mounted() {
//			console.log(this.Limits.dealer_create)
//			console.log("this.$router",this.$router)
      var user = sessionStorage.getItem('user');
      if (user) {
//				user = JSON.parse(user);
        this.sysUserName = user.name || '';
        this.sysUserAvatar = user.avatar || '';
      }
    }
  }

</script>

<style scoped lang="scss">
  @import '~scss_vars';

  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;

    .header {
      height: 50px;
      line-height: 50px;
      /*background: url(../../static/img/nav2.png) no-repeat;*/
      background-color: rgb(33, 193, 220);
      background-size: 100% 100%;
      color: #fff;
      z-index: 999;
      /*border-bottom:1px solid #333;*/
      box-shadow: 0px 2px 2px #20999999;

      .userinfo {
        text-align: center;
        padding-right: 40px;
        float: right;

        p {
          margin: 0;
          padding-top: 0px;

          .userinfo-inner {
            /*margin-right:20px;*/
            margin-left: 10px;
            cursor: pointer;
            color: #fff;
          }
        }

      }

      .logo {
        width: 200px;
        height: 50px;
        font-size: 22px;
        margin-left: 50px;
        position: relative;

        img {
          display: block;
          width: 70%;
          height: auto;
          position: absolute;
          bottom: 15px;
          left: -22px;
        }

        .txt {
          color: #fff;
        }
      }

      .logo-width {
        width: 230px;
      }

      .logo-collapse-width {
        width: 60px
      }

      .tools {
        padding: 0px 23px;
        width: 14px;
        height: 60px;
        line-height: 60px;
        cursor: pointer;
      }
    }

    .main {
      display: flex;
      // background: #324057;
      position: absolute;
      top: 60px;
      bottom: 0px;
      overflow: hidden;

      aside {
        flex: 0 0 200px;
        width: 200px;
        // position: absolute;
        // top: 0px;
        // bottom: 0px;

        .el-menu {
          height: 100%;
          background: none;
          border: none;
          overflow-y: auto;
        }

        .collapsed {
          width: 60px;

          .item {
            position: relative;
          }

          .submenu {
            position: absolute;
            top: 0px;
            left: 60px;
            z-index: 99999;
            height: auto;
            display: none;
          }

        }
      }

      .menu-collapsed {
        flex: 0 0 60px;
        width: 60px;
      }

      .menu-expanded {
        flex: 0 0 230px;
        width: 230px;
      }

      .content-container {
        flex: 1;
        position: absolute;
        right: 0px;
        top: 0px;
        bottom: 0px;
        left: 230px;
        overflow-y: auto;
        padding: 10px 10px 0px 10px;

        .breadcrumb-container {
          /*margin-bottom: 15px;*/
          height: 3%;

          .title {
            width: 200px;
            float: left;
            color: #475669;
          }

          .breadcrumb-inner {
            float: right;
          }
        }

        .content-wrapper {
          background-color: #fff;
          box-sizing: border-box;
          height: 97%;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Home.vue?182ec8f0